module.exports = __webpack_public_path__ + "img/c00_buildingtechscalemail_Normal_ua.66b6dc77.webp";